import React from 'react'
import {Dropdown as TPADropdown} from 'wix-ui-tpa/cssVars'
import type {DropdownProps as TPADropdownProps} from 'wix-ui-tpa/cssVars'

import {st, classes} from './styles.st.css'

export const Dropdown = ({className, ...rest}: TPADropdownProps) => {
  return <TPADropdown className={st(className, classes.dropdown)} {...rest} />
}
